import styled from 'styled-components';

export const FooterDiv = styled.footer`
  // z-index: 3;
  display: flex;
  justify-content: center;
  flex-direction: row; /* Ordem padrão */
  align-items: center;
  width: 100%;
  gap: 5rem;
  padding: 1vh;
  height: 115px;
  background: ${({ theme }) => theme.footBg};
  bottom: 0;
  // position: absolute;

  /* Ordem padrão */
  div:nth-child(1) {
    order: 1; /* Logo */
  }

  section {
    order: 2;
    border-left: 1px solid ${({ theme }) => theme.footFont}; /* Cor da borda esquerda */
    flex-direction: column;
    margin: 1px;
    padding-left: 10px; /* Adiciona espaço dentro da borda esquerda */
    padding-right: 10px; /* Adiciona espaço dentro da borda esquerda */
    /* height: 75px; */
    @media (width < 901px) {
      border-left: 0;
      text-align: center;
    }
  }

  div:nth-child(2) {
    order: 3; /* Links */
  }

  div {
    display: flex;
    gap: 1rem;
    a {
      img {
        width: 30px;
        filter: invert(0);
      }
    }
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 13px; /* Corrigido de 18x para 18px */
    line-height: 15px;
    color: ${({ theme }) => theme.footFont};
    font-family: 'Roboto Regular', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 25px;
    letter-spacing: 0.02em;
    @media (max-width: 900px) {
      margin: 5px 0 5px 0;
    }
  }
  @media (max-width: 900px) {
    flex-direction: column; /* Muda para coluna */
    width: 100%;
    height: 505px;
    gap: 2rem;
    padding: 0 18px 0 18px;
    /* Nova ordem */
    div:nth-child(1) {
      order: 2; /* Logo */
    }
    div:nth-child(2) {
      order: 1; /* Links */
    }

    section {
      order: 3; /* Section */
    }
    div {
      display: flex;
      gap: 1rem;
      a {
        img {
          width: 45px;
          filter: invert(0);
        }
      }
    }
  }
`;

export const Logo = styled.div`
  // position: relative;
  // display: inline-block;
  // top: 0
  align-items: center;
  display: flex;
  width: 25vh;
  height: 10vh;

  background-image: url(${({ theme }) => theme.footLogo});
  background-repeat: no-repeat;
  background-size: 150px;
  background-position: center;

  @media (max-width: 900px) {
    background-size: 234px;
    width: 234px;
  }
`;
